#import "./BarMitzvahDetails.graphql"
query MyBarMitzvotQuery {
  myBarMitzvot {
    ...barMitzvahDetails
  }
}
